export enum TaskListMode {
  Daily = 'daily',
  Weekly = 'weekly',
}
